/**
 * NewProjectCard molecule — dashed-outline card that matches ProjectCard size.
 * Clicking it triggers the new-idea flow (handled by parent).
 */
"use client";

import React from "react";
import { cn } from "@/lib/utils";
import { Plus } from "lucide-react";

export interface NewProjectCardProps {
  onClick: () => void;
  className?: string;
}

export function NewProjectCard({ onClick, className }: NewProjectCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "group block w-full overflow-hidden rounded-[22px] border-2 border-dashed border-slate-300 bg-slate-50/80 text-left transition hover:-translate-y-0.5 hover:border-slate-400 hover:bg-slate-100/80 hover:shadow-[0_12px_32px_rgba(2,8,23,0.08)]",
        className,
      )}
    >
      <div className="px-3 pt-3">
        <div className="relative flex aspect-[16/9] w-full flex-col items-center justify-center overflow-hidden rounded-2xl border-2 border-dashed border-slate-200 bg-white/60">
          <Plus className="h-10 w-10 text-slate-400 transition group-hover:text-slate-500" />
          <span className="mt-2 text-sm font-medium text-slate-500">
            New project
          </span>
        </div>
      </div>
      <div className="flex min-h-[60px] items-center justify-between px-4 py-3">
        <span className="text-sm font-medium text-slate-600">
          Start a new idea
        </span>
      </div>
    </button>
  );
}
